var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid",on:{"mouseenter":_vm.showOnlyButtons}},[_c('div',{staticClass:"col-12"},[_vm._l((_vm.routerOptions),function(option){return [(
          option.navFooter &&
            (option.isAuthorized ? option.isAuthorized == _vm.isAuthorized : true)
        )?_c('b-nav-item',{key:option.name,attrs:{"to":option.path}},[_vm._v(_vm._s(option.name))]):_vm._e()]})],2)])}
var staticRenderFns = []

export { render, staticRenderFns }